import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Movie API
export const movieApi = {
  get: () => api.get('/movie'),
  update: (data) => api.put('/movie', data),
};

// Media API
export const mediaApi = {
  get: () => api.get('/media'),
  update: (data) => api.put('/media', data),
};

// Cinemas API
export const cinemasApi = {
  getAll: () => api.get('/cinemas'),
  create: (data) => api.post('/cinemas', data),
  update: (id, data) => api.put(`/cinemas/${id}`, data),
  delete: (id) => api.delete(`/cinemas/${id}`),
};

// Sessions API
export const sessionsApi = {
  getByCinema: (cinemaId) => api.get(`/cinemas/${cinemaId}/sessions`),
  create: (cinemaId, data) => api.post(`/cinemas/${cinemaId}/sessions`, data),
  update: (sessionId, data) => api.put(`/sessions/${sessionId}`, data),
  delete: (sessionId) => api.delete(`/sessions/${sessionId}`),
};

// Settings API
export const settingsApi = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
};

// Pages CMS API
export const pagesApi = {
  getAll: () => api.get('/pages'),
  get: (slug) => api.get(`/pages/${slug}`),
  update: (slug, data, token) => api.put(`/pages/${slug}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  }),
};

// Site Config API
export const siteConfigApi = {
  get: () => api.get('/site-config'),
  update: (data, token) => api.put('/site-config', data, {
    headers: { Authorization: `Bearer ${token}` }
  }),
};

export default api;
